import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
export const CMS_CONFIG_SIZEBAY = 'sizebay';
export interface IICmsConfigSizebayDataContent extends IConfigData {
    sizebayEnabled?: boolean;
}
export interface IICmsConfigSizebayData extends IConfigData<IICmsConfigSizebayDataContent> {}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_SIZEBAY,
    name: 'Sizebay configuration',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'sizebayEnabled',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Sizebay enabled',
            default: false
        }
    ]
});
